/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignGenerateRequest, CampaignGenerateResponse } from '../types/CampaignGenerate'

/**
 * POST /campaigns/generate
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::generate
 */
export async function campaignGenerate(
	data: CampaignGenerateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignGenerateResponse>> {
	return axiosInstance.post('/campaigns/generate', data, config)
}
